/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  GET_AUTHOR,
  GET_CATEGORY,
  GET_FREE_TAG,
  GET_REPORT_DOWNLOAD,
  GET_SUBJECT_TAG,
} from '../../../../action/apiPath';
import { CallWithAuth } from '../../../../action/apiActions';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_LOD, Get_QDR_Report, Get_Report_List, GetReportQuestionBank } from '../../../../redux/action';
import FilterModal from '../../../atoms/Modal/FilterModal';
import ReportFilterModal from '../../../atoms/Modal/ReportFilterModal';
import style from '../../../../assets/styles/userManagement.module.css';
import NativeButton from '../../../atoms/Button';
import { GetOraganisationDetails, GetOraganisationList } from '../../../../redux/action';
import { Pagination } from '../../common/Pagination';
import { useNavigate, useParams } from 'react-router-dom';
import download from '../../../../assets/images/downloadImg.svg';
import { useToast } from '../../common/Toast';
import axios from 'axios';
import Cookies from 'js-cookie';

const QuestionDistributionReport = () => {
  //  show data of all
  const limit = 15;
  const toast = useToast();
  const [last, setLast] = useState(5);
  const [offset, setOffset] = useState(0);
  const [keyword, setKeyword] = useState(null);
  const [sortOrganisation, setSortOrganisation] = useState(true);
  const { qdrList, lodList } = useSelector((state) => state.GetAllData);
  const dispatch = useDispatch();
  const organizationId = localStorage.getItem('selectedOrgId');
  const [currentPage, setCurrentPage] = useState(1);
  const [statusValue, setStatusValue] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [inputPage, setInputPage] = useState(currentPage);
  const [sortCreatedAtIcon, setSortCreatedAtIcon] = useState(true);
  const { orgList, viewReportList } = useSelector((state) => state.GetAllData);
  const [sortQuestionBankIcon, setSortQuestionBankIcon] = useState(false);
  const navigate = useNavigate();
  const [sortStatus, setSortStatus] = useState(true);
  const [sortCreatedAt, setSortCreatedAt] = useState(true);
  const [sortUserRole, setSortUserRole] = useState(true);
  const [sortStatusIcon, setSortStatusIcon] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewReport, setViewReport] = useState([]);
  const [sort, setSort] = useState('-created_at');

  useEffect(() => {
    if (currentPage && currentPage > 0) {
      setIsLoading(true);
      dispatch(Get_Report_List(organizationId, keyword, sort, limit, currentPage));
    }
  }, [organizationId, keyword, sort, limit, currentPage]);

  useEffect(() => {
    setIsLoading(true);
    setCurrentPage(1);
    setInputPage(1);
    setOffset(0);
  }, []);

  useEffect(() => {
    if (viewReportList?.count) {
      setIsLoading(false);
      const totalResults = viewReportList?.count;
      // If the current offset is greater than the total results,
      // reset to first page
      if (offset >= totalResults && totalResults > 0) {
        setOffset(0);
        setCurrentPage(1);
        setInputPage(1);
        setLast(Math.min(15, totalResults));
        setTotalCount(offset);
      } else {
        if (totalResults) {
          setTotalCount(totalResults);
          setLast(Math.min(offset + 15, totalResults));
        }
        if (!totalResults) {
          setTotalCount(0);
          setLast(1);
          setOffset(0);
        }
      }
    }
    if (viewReportList?.error) {
      setTotalCount(0);
    }
  }, [viewReportList]);

  // Add formatDateTime function
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return `${formattedDate}  |  ${formattedTime}`;
  };

  useEffect(() => {
    if (viewReportList) {
      setViewReport(viewReportList);
      setIsLoading(false);
      const totalResults = viewReportList.count;
    }
  }, [viewReportList]);

  // ________ filter modal open  ________
  const [modalFilter, setModalFilter] = useState(false);

  const openModalFilter = () => {
    setModalFilter(true);
  };

  const closeModalFilter = () => {
    setModalFilter(false);
  };

  const sortStatusFunction = () => {
    if (sortStatus) {
      setSort('status');
      setSortStatus(!sortStatus);
      setSortStatusIcon(true);
    } else {
      setSort('-status');
      setSortStatus(!sortStatus);
      setSortStatusIcon(true);
    }

    setSortQuestionBankIcon(false);
    setSortCreatedAtIcon(false);
  };

  const sortQuestionBankFunction = () => {
    setSortQuestionBankIcon(true);
    setSortCreatedAtIcon(false);
    setSortStatusIcon(false);

    if (sortOrganisation) {
      setSort('question_bank');
      setSortOrganisation(!sortOrganisation);
    } else {
      setSort('-question_bank');
      setSortOrganisation(!sortOrganisation);
    }
  };

  const getRotation = (column) => {
    if (sort === column) {
      return 'rotate(180deg)';
    }
    return 'rotate(0deg)';
  };

  const sortCreatedFunction = () => {
    setSortCreatedAtIcon(true);
    setSortQuestionBankIcon(false);
    setSortStatusIcon(false);
    if (sortCreatedAt) {
      setSort('-created_at');
      setSortCreatedAt(!sortCreatedAt);
    } else {
      setSort('created_at');
      setSortCreatedAt(!sortCreatedAt);
    }
  };

  // Function to handle opening the modal
  const handleOpenModal = () => {
    setIsModalOpen(true);
    dispatch(GetReportQuestionBank(organizationId));
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    dispatch(Get_Report_List(organizationId, keyword, sort, limit, currentPage));
  };

  const handleSearch = (e) => {
    setKeyword(e.target.value);
    setCurrentPage(1);
    setInputPage(1);
    setSortOrganisation(false);
    setSortStatus(false);
    setSort('');
    setSortCreatedAtIcon(false);
    setSortQuestionBankIcon(false);
    setSortStatusIcon(false);
  };

  const handleDownloadClick = async (id) => {
    const userInfo = localStorage?.getItem('userInfo');
    const jwt = userInfo ? JSON.parse(userInfo).jwt : '';
    try {
      const response = await axios({
        url: `${GET_REPORT_DOWNLOAD}${organizationId}/?report_id=${id}`,
        method: 'GET',
        responseType: 'blob',
        headers: {
          Authorization: `jwt ${jwt ?? Cookies.get('accessToken')}`, // Add the authentication header
        },
      });
      const contentDisposition = response.headers['Content-Disposition'] || response.headers['content-disposition'];

      // Extract file name from Content-Disposition
      let fileName = 'default_filename'; // Fallback filename
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=(['"]?)(.*?)(\1|$)/);
        if (fileNameMatch?.[2]) {
          fileName = fileNameMatch[2]; // Extracted file name
        }
      }

      // Create a blob and trigger file download
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/octet-stream',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Download Error:', error);
      if (toast) {
        toast.add('Failed to download file. Please try again.', 'error');
      }
    }
  };

  return (
    <div className={style.question_bank_table_top}>
      <div className={style.question_bank}>
        {/* TABLE SECTION OF THIS PAGE  */}
        <div className={`${style.table_content_report} ${style.user_table_content} ${style.user_table_content_new}`}>
          {/* _______________________Top content of table_______________________  */}
          <div className={style.top_content_table}>
            {/*_______________________  Search bar  _______________________ */}
            <div className={` ${style.search_listing} ${style.user_management_search_listing}`}>
              <div className={style.tag_icon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                    stroke="#212529"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.2598 19.2592L16.1406 16.8594"
                    stroke="#212529"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={style.input_search}>
                <input
                  type="search"
                  id="searchInput"
                  placeholder="Search here..."
                  onChange={(e) => {
                    handleSearch(e);
                  }}
                />
              </div>
            </div>
            {/*_______________________ Generate Report Button  _______________________ */}
            <div className={style.add_question}>
              <button
                className={` ${style.add_new_question} ${style.pointer} ${style.OrgButton}`}
                onClick={() => handleOpenModal()}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" fill="white" />
                  <path
                    d="M7.5 12H16.5"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 16.5V7.5"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Generate Report</span>
              </button>
            </div>
          </div>

          {/* TABLE LISTING OF REPORT  */}
          {totalCount !== 0 ? (
            <div className={`${style.sub_head_content_table} ${style.sub_head_content_table_report}`}>
              <table>
                <thead>
                  <tr>
                    <th
                      className={` ${style.first} ${style.first_new} ${style.pointer}`}
                      onClick={() => sortCreatedFunction()}
                    >
                      <span>Created At</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-created_at'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>

                    <th
                      className={` ${style.first} ${style.second_new} ${style.pointer}`}
                      onClick={() => sortQuestionBankFunction()}
                    >
                      <span>Question Bank</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-question_bank'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>
                    <th className={` ${style.first} ${style.third_new}`}>
                      <span>Question Type</span>
                    </th>

                    <th className={` ${style.first} ${style.fourth_new}`}>Category</th>
                    <th className={` ${style.first} ${style.fifth_new}`}>Author</th>
                    <th className={` ${style.first} ${style.sixth_new}`}>Academic Year</th>

                    <th
                      className={` ${style.first} ${style.seventh_new} ${style.pointer}`}
                      onClick={() => !statusValue && sortStatusFunction()}
                    >
                      <span>Status</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-status'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>

                    <th className={` ${style.first} ${style.eighth_new} ${style.pointer}`}></th>
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody>
                    <tr>
                      <td colSpan="7" className={style.loader_message}>
                        Loading...
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {viewReport?.results?.map((item, i) => (
                      <tr key={i} className={style.table_body_content}>
                        <td>
                          <div
                            className={`${style.user_management_table_body_content} ${style.userFirstname}`}
                            style={{ width: '132px' }}
                          >
                            <div
                              className={style.created_class}
                              onClick={() => {
                                navigate(`/view-distribution-report-detail/${item.id}`);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              {formatDateTime(item?.created_at)}
                            </div>
                            <div className={item?.keyword ? style.keyword_class : ''}>{item?.keyword}</div>
                          </div>
                        </td>
                        <td>
                          <div
                            className={`${style.user_management_table_body_content} ${style.userLasttname}`}
                            style={{ width: '105px' }}
                          >
                            {item?.question_bank}
                          </div>
                        </td>
                        <td>
                          <div
                            className={`${style.user_management_table_body_content} ${style.user_management_table_body_content_new}`}
                          >
                            {item?.question_type?.length > 3 ? (
                              <>
                                <span className={style.tag_class}>{item.question_type[0]}</span>
                                <span className={style.tag_class}>{item.question_type[1]}</span>
                                <div className={style.inline_tags}>
                                  <span className={style.tag_class}>{item.question_type[2]}</span>
                                  <span className={`${style.tag_class_round}`}>
                                    {` ${item.question_type.length - 3}+`}
                                  </span>
                                </div>
                              </>
                            ) : (
                              item?.question_type?.map((type, index) => (
                                <span key={index} className={style.tag_class}>
                                  {type}
                                </span>
                              ))
                            )}
                          </div>
                        </td>
                        <td>
                          <div
                            className={`${style.user_management_table_body_content} ${style.user_management_table_body_content_new}`}
                          >
                            {item?.category?.length > 3 ? (
                              <>
                                <span className={style.tag_class}>{item.category[0]}</span>
                                <span className={style.tag_class}>{item.category[1]}</span>
                                <div className={style.inline_tags}>
                                  <span className={style.tag_class}>{item.category[2]}</span>
                                  <span className={`${style.tag_class_round}`}>{` ${item.category.length - 3}+`}</span>
                                </div>
                              </>
                            ) : (
                              item?.category?.map((type, index) => (
                                <span key={index} className={style.tag_class}>
                                  {type}
                                </span>
                              ))
                            )}
                          </div>
                        </td>

                        <td>
                          <div
                            className={`${style.user_management_table_body_content} ${style.user_management_table_body_content_new}`}
                          >
                            {item?.author?.length > 3 ? (
                              <>
                                <span className={style.tag_class}>{item.author[0]}</span>
                                <span className={style.tag_class}>{item.author[1]}</span>
                                <div className={style.inline_tags}>
                                  <span className={style.tag_class}>{item.author[2]}</span>
                                  <span className={`${style.tag_class_round}`}>{` ${item.author.length - 3}+`}</span>
                                </div>
                              </>
                            ) : (
                              item?.author?.map((type, index) => (
                                <span key={index} className={style.tag_class}>
                                  {type}
                                </span>
                              ))
                            )}
                          </div>
                        </td>

                        <td>
                          <div className={`${style.user_management_table_body_content} ${style.userOrganization}`}>
                            <span> {item?.academic_year}</span>
                          </div>
                        </td>
                        <td>
                          <div
                            className={`
                              ${style.statusButton} 
                              ${item?.status === 'Success' ? style.success : ''} 
                              ${item?.status === 'Pending' ? style.pending : ''} 
                              ${item?.status === 'Failed' ? style.failed : ''} 
                              ${item?.status === 'Progress' ? style.inprogress : ''}
                           `}
                          >
                            <span>{item?.status}</span>
                            {item?.status === 'Failed' && (
                              <span className={style.customErrorMessage}>
                                <span className={style.errorTitle}>Data Retrieval Issue: </span>
                                <span className={style.errorMessage}>{item.status_message}</span>
                              </span>
                            )}
                          </div>
                        </td>

                        <td>
                          {item?.status === 'Success' && (
                            <div className={style.download_class} onClick={() => handleDownloadClick(item?.id)}>
                              <span>
                                <img src={download} alt="downloadimg" />
                              </span>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          ) : (
            <>
              {viewReportList?.error ? (
                <div className={style.noData}>
                  <div className={style.noDataText}>
                    No Results Found. We couldn&apos;t find anything that matches your search. Please try using
                    different keywords
                  </div>
                </div>
              ) : (
                <div colSpan="7" className={style.loader_message}>
                  Loading...
                </div>
              )}
            </>
          )}
        </div>
        {/*______________________________ PAGINATION ______________________________  */}
        <div className={`${style.user_paginationWrap}`}>
          {totalCount !== 0 && (
            <Pagination
              totalCount={totalCount}
              limit={limit}
              currentPage={currentPage}
              inputPage={inputPage}
              offset={offset}
              last={last}
              nextUrl={viewReportList.next}
              prevUrl={viewReportList.previous}
              setOffset={setOffset}
              setCurrentPage={setCurrentPage}
              setInputPage={setInputPage}
              setLast={setLast}
            />
          )}
        </div>

        {/*______________________________ PAGINATION ______________________________  */}
      </div>
      {/* Render modal when isModalOpen is true */}
      <ReportFilterModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};
export default QuestionDistributionReport;
